import React, { FC } from "react";
import { SvgWrapper } from "./SvgWrapper";
import { SVGProps } from "../../utils";

export const Schedule: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 12.6923H20V15H0V12.6923ZM17.7778 6.92308V8.07692H2.22222V6.92308H17.7778ZM20 4.61538H0V10.3846H20V4.61538ZM0 0H20V2.30769H0V0Z" fill="#434649" fillOpacity="0.85"/>
    </svg>
  </SvgWrapper>  
);
